module.exports = __webpack_public_path__ + "static/media/tick_ic.561df54b.svg";